var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 4V7.2M10.8 4V7.2",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 5.6001H13.2C10.1831 5.6001 8.67457 5.6001 7.7373 6.53735C6.80005 7.47462 6.80005 8.98311 6.80005 12.0001V13.6001C6.80005 16.6171 6.80005 18.1256 7.7373 19.0628C8.67457 20.0001 10.1831 20.0001 13.2 20.0001H14.8C17.817 20.0001 19.3256 20.0001 20.2628 19.0628C21.2 18.1256 21.2 16.6171 21.2 13.6001V12.0001C21.2 8.98311 21.2 7.47462 20.2628 6.53735C19.3256 5.6001 17.817 5.6001 14.8 5.6001Z",
    fill: "#4F46E5",
    stroke: "#4F46E5",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9964 13.6001H14.0036M13.9964 16.8001H14.0036M17.1928 13.6001H17.2M10.8 13.6001H10.8072M10.8 16.8001H10.8072",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenIc);
export default __webpack_public_path__ + "static/media/calen_ic.b0f8c8a3e7528b7afdf732bfbf6b9482.svg";
export { ForwardRef as ReactComponent };